export const FIELD_CATEGORY_ENUM = Object.freeze({
  DEAL: 'DEAL',
  PARTNER_INFO: 'PARTNER_INFO',
})

export const FIELD_CATEGORY_LABELS = Object.freeze({
  [FIELD_CATEGORY_ENUM.DEAL]: 'Deal Registration',
  [FIELD_CATEGORY_ENUM.PARTNER_INFO]: 'Partner Data',
})

export const FORM_STATUS_ENUM = Object.freeze({
  RESPONSE_PENDING: 'Response Pending',
  COMPLETE: 'Complete',
})

export const FIELD_GROUP_ENUM = Object.freeze({
  CONTACT: 'contact',
})